import axios from '../utils/axios';

export default function cloneMailer(adminId, id) {
    return (
        axios.post(`/admin/${adminId}/tag-mailers/${id}/clone`, {})
    )
}
